import { render, staticRenderFns } from "./ChildSurvey.vue?vue&type=template&id=2569537c"
import script from "./ChildSurvey.vue?vue&type=script&lang=ts"
export * from "./ChildSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports